import { push } from 'connected-react-router';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';


export const getInvitation = (payload) => (dispatch) => (
  dispatch(actions.getInvitation(payload))
);

export const acceptInvitation = (payload) => (dispatch) => (
  dispatch(actions.acceptInvitation(payload))
    .then(() => dispatch(push('/dashboard/tests')))
);

export const moveInvitation = (payload) => (dispatch) => (
  dispatch(actions.moveInvitation(payload))
    .then(() => dispatch(push('/dashboard/tests')))
);

export const declineInvitation = (payload) => (dispatch) => (
  dispatch(actions.declineInvitation(payload))
    .then(() => dispatch(push('/dashboard/tests')))
);

export const onCaptchaError = () => (dispatch) => (
  dispatch(notificationActions.notifyDanger('Captcha error, please validate if your network connection is stable.'))
);

export const onCaptchaExpired = () => (dispatch) => (
  dispatch(notificationActions.notifyDanger('Captcha expired, please retry.'))
);
